import React from 'react';
import { motion } from 'framer-motion';
import { FaMoneyBillWave, FaCarSide, FaPercent, FaCalendarAlt, FaTimes, FaHeadset, FaAward, FaCarAlt } from 'react-icons/fa';
import bgImage from '../../assets/images/MCE-26334-DEST-Mykonos-Main_Sunset.jpg';

const FeatureCard = ({ icon: Icon, title, description, index }) => {
  return (
    <motion.div
      className="flex flex-col items-center text-center p-6 bg-white/30 backdrop-blur-md rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border border-white/20"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <motion.div 
        className="w-16 h-16 rounded-full bg-primary/20 backdrop-blur-sm flex items-center justify-center text-white mb-4"
        whileHover={{ scale: 1.1, rotate: 5 }}
      >
        <Icon className="w-8 h-8" />
      </motion.div>
      <h3 className="text-lg font-bold mb-2 text-white drop-shadow-md">{title}</h3>
      <p className="text-white/90 text-sm font-medium drop-shadow-md">{description}</p>
    </motion.div>
  );
};

const Features = () => {
  const features = [
    {
      icon: FaMoneyBillWave,
      title: "Fixed rates",
      description: "Transparent pricing with no hidden fees"
    },
    {
      icon: FaCarSide,
      title: "Reliable transfers",
      description: "Highest standards of quality & safety"
    },
    {
      icon: FaPercent,
      title: "No booking fees",
      description: "Save money by talking directly to us"
    },
    {
      icon: FaCalendarAlt,
      title: "Booking flexibility",
      description: "Flexible booking changes anytime you need"
    },
    {
      icon: FaTimes,
      title: "Free cancellation",
      description: "Cancel your mykonos transfer at no charge up to ONE hour before the arranged time"
    },
    {
      icon: FaHeadset,
      title: "24/7 Customer Service",
      description: "We are here for our customers 24/7 tasking care of their needs"
    },
    {
      icon: FaAward,
      title: "Award winning service",
      description: "Most Reliable Mykonos Transfer Services on the island of Mykonos"
    },
    {
      icon: FaCarAlt,
      title: "Quality Luxury Vehicles",
      description: "Relax with our well-maintained fleet for comfortable Mykonos Transfer"
    },
  ];

  return (
    <section className="relative overflow-hidden">
      {/* Top gradient divider */}
      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-white to-transparent z-10"></div>
      
      <div className="py-16 relative overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          {/* Dark overlay for better readability */}
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <motion.h2 
            className="text-3xl font-bold text-center mb-12 text-white drop-shadow-lg"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Why Choose Our Transfer Service
          </motion.h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <FeatureCard
                key={index}
                icon={feature.icon}
                title={feature.title}
                description={feature.description}
                index={index}
              />
            ))}
          </div>
        </div>
      </div>
      
      {/* Bottom gradient divider */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default Features;
